
<template>
  <div>
    <b-button
      v-permission="'users.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew"
    >
      <feather-icon
        icon="PlusIcon"
        class="mr-50"
      />
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>

    <Grid :service="service" route_name="users"></Grid>
  </div>
</template>


<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import UserService from '@/services/api/UserService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    addNew() {
      this.$router.push('/users/create')
    }
  },
  beforeMount() {
    this.service = UserService.build(this.$vs)
  }
}
</script>